import script from "./MyChartBookForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MyChartBookForm.vue?vue&type=script&setup=true&lang=js"

import "./MyChartBookForm.vue?vue&type=style&index=0&id=0840d174&lang=scss"

const __exports__ = script;

export default __exports__